import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BranchesInternationalImplRepository } from './branches-international-imp.respository';
import { BranchesInternationalRepository } from '@/core/domain/branches-international/repositories/branches-international.repository';
import { FindBranchesInternationalUseCase } from '@/core/domain/branches-international/usecases/findBranchesInternational.usecase';
import { GetAvailabilityInternationalUseCase } from '@/core/domain/branches-international/usecases/getAvailabilityInternational.usecase';
import { ClearLocationIntUseCase } from '@/core/domain/branches-international/usecases/clearLocationInt.usecase';
import { SaveLocationIntUseCase } from '@/core/domain/branches-international/usecases/saveLocationInt.usecase';

const findBranchesInternationalUseCaseFactory = (
    branchesInternationalRepository: BranchesInternationalRepository,
) => new FindBranchesInternationalUseCase(branchesInternationalRepository);

const getAvailabilityInternationalUseCaseFactory = (
    branchesInternationalRepository: BranchesInternationalRepository,
) => new GetAvailabilityInternationalUseCase(branchesInternationalRepository);

const clearLocationIntUseCaseFactory = (
    branchesInternationalRepository: BranchesInternationalRepository,
) => new ClearLocationIntUseCase(branchesInternationalRepository);

const saveLocationIntUseCaseFactory = (
    branchesInternationalRepository: BranchesInternationalRepository,
) => new ClearLocationIntUseCase(branchesInternationalRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: FindBranchesInternationalUseCase,
            useFactory: findBranchesInternationalUseCaseFactory,
            deps: [BranchesInternationalImplRepository],
        },
        {
            provide: GetAvailabilityInternationalUseCase,
            useFactory: getAvailabilityInternationalUseCaseFactory,
            deps: [BranchesInternationalImplRepository],
        },
        {
            provide: ClearLocationIntUseCase,
            useFactory: clearLocationIntUseCaseFactory,
            deps: [BranchesInternationalImplRepository],
        },
        {
            provide: SaveLocationIntUseCase,
            useFactory: saveLocationIntUseCaseFactory,
            deps: [BranchesInternationalImplRepository],
        },
        {
            provide: BranchesInternationalRepository,
            useClass: BranchesInternationalImplRepository,
        },
    ],
})
export class BranchesInternationalModule {}
